export const ALBUM_PROMO_COLLECTION = '3827'

export function isAlbumPage(productClusters: any) {
  if (!productClusters) {
    return false
  }

  return productClusters.some(
    (cluster: { id: string; name: string }) =>
      cluster.id === ALBUM_PROMO_COLLECTION
  )
}
